var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuestic-page-not-found-large-text" },
    [
      _c("div", { staticClass: "vuestic-page-not-found-large-text__content" }, [
        _c(
          "div",
          { staticClass: "vuestic-page-not-found-large-text__wallpaper" },
          [
            _c("router-link", {
              staticClass:
                "i-vuestic vuestic-page-not-found-large-text__i-vuestic",
              attrs: { to: { path: "/" } },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vuestic-page-not-found-large-text__wallpaper" },
          [
            _c("img", {
              staticClass: "sys-error-img",
              attrs: { src: _vm.subjectAddressUrl, alt: "In Maintenance" },
            }),
          ]
        ),
        _vm._m(0),
        _c(
          "div",
          {
            staticClass:
              "vuestic-page-not-found-large-text__wallpaper-button flex md12",
            staticStyle: { "z-index": "9999" },
          },
          [
            _c("router-link", { attrs: { to: { path: "/dashboard" } } }, [
              _c("button", { staticClass: "btn btn-primary back-button" }, [
                _vm._v(
                  "\n          " + _vm._s("Back to dashboard") + "\n        "
                ),
              ]),
            ]),
          ],
          1
        ),
      ]),
      _c("vuestic-page-not-found-sad-wallpaper"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "vuestic-page-not-found-large-text__wallpaper" },
      [
        _c("h3", { staticClass: "vuestic-page-not-found-large-text__text" }, [
          _vm._v("The page's gone\n        fishing."),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }